<template>
  <div class="shelf-box">
    <van-nav-bar :border="false" fixed>
      <template #left> <span class="shelf-title">Library</span> </template>
      <template #right>
        <span @click="goHistory" class="nv-icon icon-history top-icon"></span>
        <span @click="openSelectMode" class="nv-icon icon-edit top-icon"></span>
      </template>
    </van-nav-bar>
    <NvBookGrid :books="allBooks">
      <div v-if="allBooks.length < 1" slot="empty" class="empty">
        <div class="empty-tip">
          You have not added any <br />
          stories to the library yet.
        </div>
        <van-button size="large" round class="btn" @click="goDiscover">
          Discover Now
        </van-button>
      </div>
      <span @click="goDiscover('btn')" slot="append" class="nv-icon icon-add icon-big"></span>
    </NvBookGrid>
    <!-- edit selection box -->
    <van-popup v-model="selectable" class="edit-box">
      <van-nav-bar :border="false" fixed>
        <template #left>
          <van-icon @click="closeSelectMode" name="cross" color="#333333" size="20" />
        </template>
        <template #title> <span class="shelf-title">Edit Library</span> </template>
        <template #right>
          <span @click="toggleSelectAll" class="select-tip">
            {{ selectedAll ? "Unselect All" : "Select All" }}
          </span>
        </template>
      </van-nav-bar>
      <NvBookGrid :books="books" :selectable="true" />
      <div v-if="selectedBooks && selectedBooks.length > 0" class="flex-center delete-btn-box">
        <van-icon @click="openConfirmModal" name="delete" size="24" color="#A0A4A8" />
        <div class="remove-tip">Remove</div>
      </div>
      <NvConfirm
        title="Remove"
        content="Are you sure to remove ?"
        :show="showComfirmBox"
        @cancel="cancelRemove"
        @confirm="confirmRemove"
      />
    </van-popup>
  </div>
</template>

<script>
import { getBooksFromLib, removeBooksFromLib, getShelfRecommend } from "@/service/api";
import NvBookGrid from "@/components/layout/NvBookGrid";
import NvConfirm from "@/components/widget/NvConfirm";

export default {
  name: "BookShelf",
  components: {
    NvBookGrid,
    NvConfirm
  },
  data() {
    return {
      bookIds: [],
      books: [],
      recommendBooks: [],
      selectable: false,
      showComfirmBox: false
    };
  },
  computed: {
    selectedBooks() {
      return this.books.filter(book => book.selected);
    },
    selectedAll() {
      return this.selectedBooks.length === this.books.length;
    },
    allBooks() {
      const all = [...this.books, ...this.recommendBooks];
      let uniqMap = {},
        uniqList = [],
        temp = null;
      for (let i = 0; i < all.length; i++) {
        temp = all[i];
        if (!uniqMap[temp.id]) {
          uniqMap[temp.id] = true;
          uniqList.push(temp);
        }
      }
      return uniqList;
    }
  },
  methods: {
    openSelectMode() {
      this.selectable = true;
      window.$event("Shelf_Edit_Show", {});
    },
    closeSelectMode() {
      // reset
      this.books.forEach(book => {
        this.$set(book, "selected", false);
      });
      this.selectable = false;
    },
    getRecommend() {
      getShelfRecommend().then(res => {
        try {
          this.recommendBooks = res[0].detail;
        } catch (e) {
          console.error(e);
          this.recommendBooks = [];
        }
      });
    },
    openConfirmModal() {
      this.showComfirmBox = true;
    },
    cancelRemove() {
      this.showComfirmBox = false;
    },
    toggleSelectAll() {
      const isAll = this.selectedAll;
      this.books.forEach(book => {
        this.$set(book, "selected", !isAll);
      });
    },
    confirmRemove() {
      window.$event("Shelf_DeleteConfirm_Click", {});
      const selectedBookIds = this.selectedBooks.map(b => b.id);
      removeBooksFromLib(selectedBookIds).finally(() => {
        this.showComfirmBox = false;
        this.selectable = false;
        this.getLibBooks();
      });
    },
    goDiscover(tag) {
      tag === "btn" && window.$event("Shelf_AddMore_Click", {});
      this.$router.push({ name: "discover" });
    },
    goHistory() {
      this.$router.push({ name: "history" });
    },
    getLibBooks() {
      getBooksFromLib().then(res => {
        this.books = res || [];
      });
    }
  },
  // mounted() {
  //   this.getLibBooks();
  //   this.getRecommend();
  //   window.$event("Shelf_Show", {});
  // },
  activated() {
    this.getLibBooks();
    this.getRecommend();
    window.$event("Shelf_Show", {});
  }
};
</script>

<style lang="scss" scoped>
.shelf-box {
  .shelf-title {
    font-size: $fs-xl;
    font-weight: 500;
  }
  .top-icon {
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    &:first-child {
      margin-right: 20px;
    }
  }
  .empty {
    font-size: $fs-l;
    color: $fc-grey;
    text-align: center;
    padding: 100px 50px;
    .empty-tip {
      margin-bottom: 24px;
    }
    .btn {
      background: linear-gradient(135deg, $bg-l-start 0%, $bg-l-end);
      color: white;
      width: 70%;
    }
  }
  .edit-box {
    height: 100%;
    width: 100%;
    background: white;
    .select-tip {
      color: $color-main;
    }
    .delete-btn-box {
      height: 50px;
      background: white;
      position: fixed;
      bottom: 0;
      width: 100%;
      flex-direction: column;
      .remove-tip {
        font-size: $fs-xxs;
        display: block;
        color: $fc-grey;
      }
    }
  }
}
</style>
